import { FlightState } from "@/lib/redux/features/flight/type"
import { isGalileoSystem } from "@/utils/flight/isGalileoSystem"

// Hành vi CŨ: giữ nguyên thứ tự đã sort, chỉ đẩy vé Galileo/1G xuống cuối.
// Dùng cho các mode sort tường minh (rẻ nhất / giờ bay sớm / muộn).
export const commonSort = (state: FlightState, flightIds: any[]) => {
  const fares = state.flightsResult.fares

  const flights = flightIds.reduce(([_1GFlights, otherFlights], flightId) => {
    const flight = state.flightsResult.flights[flightId]
    if (isGalileoSystem(fares[flight.fareDataId].system)) {
      _1GFlights.push(flightId)
    } else {
      otherFlights.push(flightId)
    }
    return [_1GFlights, otherFlights]
  }, [[], []] as [string[], string[]])
  return flights[1].concat(flights[0])
}
